import styled from 'styled-components';

const Brand = styled.h1`
  ${({ fontSize }) => `font-size: ${fontSize}`};
  letter-spacing: 1px;
  line-height: 18px;
  text-transform: uppercase;
  cursor: pointer;
  > a,
  div {
    ${({ fontSize }) => `font-size: ${fontSize}`};
    font-family: 'Avenir Black', 'Arial Black', sans-serif;
    line-height: normal;
  }
`;

export default Brand;
